export const SKILL_OPTIONS = [
  { value: 'mecanico', label: 'Mecanico' },
  { value: 'gomeria', label: 'Gomeria' },
  { value: 'taller', label: 'Taller' },
  { value: 'lavadero', label: 'Lavadero' },
  { value: 'lubricentro', label: 'Lubricentro' },
  { value: 'diagnostico', label: 'Diagnostico' },
  { value: 'electricidad', label: 'Electricidad' },
  { value: 'alineacion', label: 'Alineacion' },
  { value: 'balanceo', label: 'Balanceo' }
];

export const PERMISSION_OPTIONS = [
  { id: 'dashboard', name: 'Ver Dashboard', category: 'General' },
  { id: 'clients', name: 'Clientes', category: 'Clientes' },
  { id: 'fleets', name: 'Flotas corporativas', category: 'Clientes' },
  { id: 'appointments', name: 'Turnos', category: 'Turnos' },
  { id: 'alerts', name: 'Ver Alertas del sistema', category: 'General' },
  { id: 'wes_operator', name: 'Operar WES', category: 'WES' },
  { id: 'wes_general', name: 'Ver WES General', category: 'WES' },
  { id: 'whatsapp', name: 'Chat / WhatsApp', category: 'Comercial' },
  { id: 'reopen_production', name: 'Volver OT a producción', category: 'Taller' },
  { id: 'reports', name: 'Reportes / Ventas / Caja', category: 'Comercial' },
  { id: 'invoices', name: 'Facturas y Notas de Crédito', category: 'Comercial' },
  { id: 'products', name: 'Productos y Servicios', category: 'Inventario' },
  { id: 'supplies', name: 'Insumos', category: 'Inventario' },
  { id: 'providers', name: 'Proveedores', category: 'Compras' },
  { id: 'current_accounts', name: 'Cuentas Corrientes', category: 'Finanzas' },
  { id: 'tasks_assign', name: 'Asignar Tareas', category: 'Tareas' },
  { id: 'request_supplies', name: 'Solicitar Insumos', category: 'Insumos' },
  { id: 'approve_supply_requests', name: 'Aprobar Pedidos Internos', category: 'Insumos' },
  { id: 'loyalty', name: 'Fidelizacion', category: 'Clientes' },
  { id: 'remitos', name: 'Diagnosticos / Remitos', category: 'Comercial' },
  { id: 'users', name: 'Gestionar Usuarios', category: 'Sistema' },
  { id: 'manage_settings', name: 'Gestionar Configuración', category: 'Sistema' },
  { id: 'view_manuals', name: 'Ver y descargar Manuales operativos', category: 'Sistema' },
  { id: 'manage_manuals', name: 'Gestionar Manuales operativos (subir/eliminar)', category: 'Sistema' },
  { id: 'manage_assets', name: 'Gestionar Equipos y herramientas', category: 'Inventario' },
  { id: 'supervisor', name: 'Supervisor (recibe avisos del personal)', category: 'Sistema' },
  { id: 'stock_alerts', name: 'Recibir alertas de stock negativo', category: 'Sistema' },
  { id: 'budget_alerts', name: 'Recibir alertas de presupuestos por vencer', category: 'Sistema' },
  { id: 'manage_staff_payments', name: 'Gestionar pagos al personal', category: 'Finanzas' },
  { id: 'manage_reclamos', name: 'Registrar y gestionar reclamos', category: 'Taller' },
  { id: 'manage_content_calendar', name: 'Calendario de contenido (Redes)', category: 'Redes' },
  { id: 'view_prices', name: 'Ver precios y montos', category: 'Sistema' },
  { id: 'create_appointments', name: 'Crear / editar / eliminar turnos', category: 'Turnos' },
];

export const ROLE_PERMISSION_PRESETS: Record<string, string[]> = {
  admin: PERMISSION_OPTIONS.map((perm) => perm.id),
  mecanico: ['clients', 'fleets', 'appointments', 'alerts', 'wes_operator', 'products'],
  cajero: ['clients', 'alerts', 'invoices', 'reports', 'view_prices', 'create_appointments'],
  recepcionista: ['clients', 'appointments', 'alerts', 'dashboard', 'view_prices', 'create_appointments'],
  operario: ['alerts', 'wes_operator', 'appointments', 'fleets'],
  cm: ['manage_content_calendar']
};
